/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { createSelector } from "@reduxjs/toolkit";
import { defenseApi } from "./api-slice";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const selectDefense = createSelector(
  (response?: IManageBaseListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectDefenseListResult = () =>
  defenseApi.endpoints.getDefenseList.select();

export const selectDefenseResponse = (data?: IManageBaseResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};


